import { Component, OnInit, Input, ViewChild, Output } from '@angular/core';
import { vPlayer } from 'src/app/models/vPlayer';
import Player from "@vimeo/player";
import { BehaviorSubject, Subject } from 'rxjs';
import { Telemetry } from 'src/app/models/telemetry';

@Component({
  selector: 'app-video',
  templateUrl: './video.component.html',
  styleUrls: ['./video.component.scss']
})
export class VideoComponent implements OnInit {
  @Input('vPlayer') vPlayer;

  public telemetry: Telemetry = new Telemetry();
  @Output('telemetryData') telemetryData = new Subject<Telemetry>();
  @Output('videoComplete') videoComplete = new BehaviorSubject<boolean>(false);

  @ViewChild('vimeo_player_container',{static:false}) vimeo_player_container;
  private player: Player;
  public playProgress:number;
  private playLoop: any;
  public showTelemetry:boolean = false;
  constructor() {

  }

  ngOnInit() {
    if(!this.vPlayer.position) this.vPlayer.position=0;
    this.telemetry.playbackPosition = this.vPlayer.position;
    this.telemetryData.next(this.telemetry);
  }

  toggleTelemetry(){
    if(this.showTelemetry){
      this.showTelemetry=false;
    }else{
      this.showTelemetry=true;
    }
  }

  ngAfterViewInit(){
      this.player = new Player(this.vimeo_player_container.nativeElement, this.vPlayer.options);
      this.player.setCurrentTime(this.vPlayer.position);
      this.player.getDuration().then(duration=> {
        this.telemetry.duration = duration;
      });

      this.player.on('play',(data)=>{
        this.updatePlaybackPosition();
      });

      this.player.on('stop',()=>{
        clearTimeout(this.playLoop);
      })

      this.player.on('seeking',()=>{
        clearTimeout(this.playLoop);
      })

      this.player.on('ended',()=>{
        clearTimeout(this.playLoop);
        this.telemetry.playbackPosition=0;
        this.telemetry.playbackPercent=0;
        this.telemetryData.next(this.telemetry);
      })


      this.player.on('pause',()=>{
        clearTimeout(this.playLoop);

      })
  }

  updatePlaybackPosition(){
    this.player.getCurrentTime().then(time=>{
      this.player.getPlaybackRate().then(rate=>{
        this.vPlayer.position = time;
        this.telemetry.playbackRate = rate;
        this.telemetry.playbackPosition = time;
        this.telemetry.playbackPercent = (100/this.telemetry.duration)*this.vPlayer.position;
        this.telemetryData.next(this.telemetry);


        if(this.videoComplete.value===false && this.telemetry.playbackPosition>(this.telemetry.duration-10)){
          this.telemetry.complete = true;
          this.videoComplete.next(true);
        }

        this.playLoop = setTimeout(()=>{
          this.updatePlaybackPosition();
        },5000);
      });

    })
  }


  play(){
    this.playLoop=null;
    this.player.play();
  }

  stop(){
    this.player.pause();
  }
}
